import React from 'react';

class AssetsStep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      detailed: false,
      details: { cash: 0, securities: 0, retirement: 0, other: 0 },
    };
  }

  get total() {
    const d = this.state.details;
    return d.cash + d.securities + d.retirement + d.other;
  }

  toggleIlliquid = (e) => {
    this.props.onChange({ include_illiquid: e.target.checked });
    if (this.props.track) this.props.track('readiness_toggle_include_illiquid', { include: e.target.checked });
  };

  applyDetailed = async () => {
    const total = this.total;
    this.props.onChange({ current_investable_assets: total });
    await this.props.onSave({ current_investable_assets: total });
  };

  handleNext = async () => {
    await this.props.onSave({});
    if (this.props.track) this.props.track('readiness_view_completed', {});
    this.props.onNext();
  };

  render() {
    const { values, onChange, onBack, saving } = this.props;
    const { detailed, details } = this.state;
    const total = this.total;

    return (
      <div className="space-y-6">
        <div>
          <p className="text-succession-text-secondary mt-1">Exclude illiquid or non-core assets. You can expand details if you prefer.</p>
        </div>
        <div>
          <label className="inline-flex items-center text-succession-text-secondary">
            <input className="mr-2" type="checkbox" checked={detailed} onChange={(e) => this.setState({ detailed: e.target.checked })} />
            <span>Use Detailed Mode</span>
          </label>
        </div>

        {detailed ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {['cash','securities','retirement','other'].map((k) => (
              <div key={k}>
                <label className="block text-sm mb-2 text-succession-text-secondary">{k.charAt(0).toUpperCase()+k.slice(1)}</label>
                <input type="number" min="0" step="1" inputMode="decimal" className="border border-succession-border rounded p-3 w-full" value={details[k]} onChange={(e) => this.setState({ details: { ...details, [k]: Math.max(0, parseFloat(e.target.value || 0)) } })} />
              </div>
            ))}
            <div className="md:col-span-2">
              <div className="font-medium text-succession-text-primary">Total: {total.toLocaleString()}</div>
              <button className="bg-succession-primary text-white px-3 py-2 rounded mt-2 hover:bg-succession-primary/90" onClick={this.applyDetailed} disabled={saving}>Apply Total</button>
            </div>
          </div>
        ) : (
          <div>
            <label className="block text-sm mb-2 text-succession-text-secondary">Total Net Investable Assets</label>
            <input type="number" min="0" step="1" inputMode="decimal" className="border border-succession-border rounded p-3 w-full" value={values.current_investable_assets} onChange={(e) => onChange({ current_investable_assets: Math.max(0, parseFloat(e.target.value || 0)) })} onBlur={() => this.props.onSave({ current_investable_assets: values.current_investable_assets })} />
          </div>
        )}

        <div className="border border-succession-border p-3 rounded bg-yellow-50">
          <label className="inline-flex items-center text-succession-text-secondary">
            <input className="mr-2" type="checkbox" checked={values.include_illiquid} onChange={this.toggleIlliquid} />
            <span>Include Illiquid/Non-Core Assets (I understand the risks of including illiquid assets in readiness planning)</span>
          </label>
        </div>

        <div className="flex justify-between">
          <button type="button" className="px-4 py-2 rounded border border-succession-border hover:border-succession-primary" onClick={onBack} aria-label="Back">Back</button>
          <button type="button" className="bg-succession-primary text-white px-4 py-2 rounded hover:bg-succession-primary/90" onClick={this.handleNext} disabled={saving} aria-label="Next">Next</button>
        </div>
      </div>
    );
  }
}
export default AssetsStep;


